import { render, staticRenderFns } from "./MediakitCard.vue?vue&type=template&id=bfb1054e&scoped=true&"
import script from "./MediakitCard.vue?vue&type=script&lang=js&"
export * from "./MediakitCard.vue?vue&type=script&lang=js&"
import style0 from "./MediakitCard.vue?vue&type=style&index=0&id=bfb1054e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb1054e",
  null
  
)

export default component.exports